import { action } from 'typesafe-actions';
import { ConfigActionsTypes, Message } from './types'

export const configMessagesConfigurationRequest = () =>
  action (ConfigActionsTypes.CONFIG_MESSAGESCONFIGURATION_REQUEST);
export const configMessagesConfigurationSuccess = (messages: Message[]) =>
  action (ConfigActionsTypes.CONFIG_MESSAGESCONFIGURATION_SUCCESS, messages);
export const configMessagesConfigurationError = (message: string) =>
  action (ConfigActionsTypes.CONFIG_MESSAGESCONFIGURATION_ERROR, message);